<!--<div class="stretched">-->
<!-- Document Wrapper
============================================= -->
<div id="about_wrapper" class="stretched clearfix" [style.position]="pageState.position" [style.top]="pageState.top + 'px'">

    <header>
        <div class="primary-menu-trigger-wrapper">
            <div id="primary-menu-trigger" (click)="onClickMiniMenuBtn($event)">
                <i class="icon-reorder"></i>
            </div>
        </div>
        <div class="logo">
            <a class="logo-icon" href="/" routerLink="/"></a>
            <div class="header-details"> | {{ "About.Title" | translate }}</div>
        </div>

        <div class="submenu" [style.top]="minimenu ? '0' : '-300px'">
            <ol>
                <li (click)="scrollToEl(about);">{{ 'About.Section.Info' | translate }}</li>
                <li (click)="scrollToEl(products, -60);">{{ 'About.Section.Products' | translate }}</li>
                <li (click)="scrollToEl(smart, -60);">{{ 'About.Section.SmartSelect' | translate }}</li>
                <li (click)="scrollToEl(team);">{{ 'About.Section.Team' | translate }}</li>
                <li routerLink="/contacts">{{ 'About.Section.Contacts' | translate }}</li>
            </ol>
        </div>
    </header>

    <!--Banner1-->

    <section id="slider" class="main-wrapper" #home>
        <div appParallax [ratio]="-0.10" class="parallax-image bg-banner1"></div>
        <div appParallax [ratio]="-0.07" class="bg-banner-text bg-banner1-text"></div>
        <div class="main-container container clearfix">
            <div class="main-content-wrap">
                <div class="heading-block left nobottomborder col-lg-8 vcenter">
                    <h1 [@HeaderH1]="HeaderState">We give your telecom Business wings to fly</h1>
                    <span class="text-blanck"  [@HeaderP]="HeaderState">{{ 'About.Main.Descr' | translate}}<br>
          </span>

                </div>
            </div>
        </div>
    </section>

    <!--ABOUT US-->

    <section id="content" #about>
        <div class="content-wrap">
            <div class="container clearfix topmargin nobottomborder">
                <div class="common-height">

                    <div class="col_full col_last text-box">
                        <div class="feature-box">
                            <h1 class="text-center">ABOUT US</h1>
                            <about-text-carusel></about-text-carusel>
                        </div>
                    </div>

                    <div class="smart_container">
                        <div class="col_one_third text-box">
                            <div class="feature-box with_icon">
                                <div class="feature-box-header">
                                    <div class="h-icon h-icon-telecom"></div>
                                    <h2>
                                        TELECOM<br> EXPERIENCE
                                    </h2>
                                </div>

                                <p>Alaris Labs has almost 15 years of experience in the telecom industry. We are a flexible
                                    company
                                    constantly developing new solutions to ensure that our clients always stay ahead of the
                                    market.</p>
                            </div>
                        </div>

                        <div class="col_one_third text-box">
                            <div class="feature-box with_icon">
                                <div class="feature-box-header">
                                    <div class="h-icon h-icon-deep"></div>
                                    <h2>
                                        DEEP<br> EXPERTISE
                                    </h2>
                                </div>

                                <p>We have deep industry-specific expertise in building products for: </p>
                                <ul>
                                    <li>A2P & P2P messaging via SMPP, HTTP, SS7, Viber, WhatsApp, RCS on both
                                        carrier-to-carrier and
                                        enterprise levels 
                                    </li>
                                    <li>voice billing & smart routing</li>
                                    <li>sophisticated analytical & reporting tools</li>
                                </ul>

                            </div>
                        </div>

                        <div class="col_one_third text-box col_last" >
                            <div class="feature-box with_icon">
                                <div class="feature-box-header">
                                    <div class="h-icon h-icon-globe"></div>
                                    <h2>
                                        AROUND <br> THE GLOBE
                                    </h2>
                                </div>
                                <p>Depending on your goals we can give you a bike to get you to the desired place avoiding a
                                    traffic jam,
                                    or a jet plane to smoothly autopilot you around the globe.
                                </p>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <!--PRODUCTS-->

            <div class="section noborder nobottommargin notopmargin" #products
                 style="padding: 230px 0px;">

                <div appParallax [ratio]="-0.05" class="parallax-image bg-banner3"></div>
                <div appParallax [ratio]="-0.03"class="parallax-image bg-banner3-1"></div>

                <div appParallax [ratio]="0.1" class="parallax-image bg-banner-text bg-banner3-text1"></div>
                <div appParallax [ratio]="0.1" class="parallax-image bg-banner-text bg-banner3-text2"></div>

                <div class="container clearfix"></div>
            </div>


            <div class="section divcenter nobottommargin notopmargin nobottompadding heading-block-products">
                <div class="heading-block center noborder">
                    <h1>Products</h1>
                    <span>We design our products to fit needs of telecom players of any size and type – mobile operators, MVNOs, large enterprises, SMS aggregators, wholesale carriers.</span>
                </div>

                <div class="container clearfix smart_container">
                    <div class="col_one_third text-box">
                        <div class="feature-box with_big_icon with_footer_btn">
                            <div class="products-icon h-icon-voice">
                                <!--<div class="h-icon h-icon-voice"></div>-->
                            </div>

                            <div class="feature-box-header">
                                <h2>
                                    Voice Solutions
                                </h2>
                            </div>

                            <p style="padding-bottom: 10px;">Empower your voice business with versatile facilities:</p>
                            <ul>
                                <li>comprehensive billing</li>
                                <li>super flexible routing</li>
                                <li>highly automated rate management</li>
                                <li>exhaustive analytics</li>
                                <li>customizable monitoring and reporting</li>
                            </ul>


                            <div class="footer_btn">
                                <a class="button button-3d"
                                   href="/voice" target="_self"
                                   routerLink="/voice" routerLinkActive="active">Check it out </a>
                            </div>


                        </div>
                    </div>

                    <div class="col_one_third text-box">
                        <div class="feature-box with_big_icon with_footer_btn">
                            <div class="products-icon h-icon-messaging">
                                <!--<div class="h-icon h-icon-voice"></div>-->
                            </div>

                            <div class="feature-box-header">
                                <h2>
                                    Messaging Solutions
                                </h2>
                            </div>

                            <!--<div class="feature-box with_icon with_footer_btn">-->
                            <!--<div class="feature-box-header">-->
                            <!--<div class="h-icon h-icon-messaging"></div>-->
                            <!--<h2><span class="neon-red">M</span>essaging-->
                            <!--<br> <span class="neon-red">S</span>olutions</h2>-->
                            <!--</div>-->
                            <p style="padding-bottom: 10px;">Complete business-cycle software support for messaging
                                companies:</p>
                            <ul>
                                <li>omnichannel SMSC</li>
                                <li>outstanding throughput capacity</li>
                                <li>seamless interconnection with carriers, enterprises, OTTs, HLRs, all sorts of 3rd-party
                                    platforms
                                </li>
                                <li>hundreds of small features for each and every purpose</li>
                            </ul>
                            <div class="footer_btn">
                                <a class="button button-3d"
                                   href="/messaging" target="_self"
                                   routerLink="/messaging" routerLinkActive="active">Check it
                                    out
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="col_one_third col_last text-box">
                        <div class="feature-box with_big_icon with_footer_btn">
                            <div class="products-icon h-icon-settings">
                                <!--<div class="h-icon h-icon-voice"></div>-->
                            </div>

                            <div class="feature-box-header">
                                <h2>
                                    Customized Development
                                </h2>
                            </div>

                            <!--<div class="feature-box with_icon with_footer_btn">-->
                            <!--<div class="feature-box-header">-->
                            <!--<div class="h-icon h-icon-custom"></div>-->
                            <!--<h2><span class="neon-red">C</span>ustomized-->
                            <!--<br><span class="neon-red">D</span>evelopment</h2>-->
                            <!--</div>-->
                            <p>You have a brilliant idea and need an experienced development team to support you with
                                excellent software
                                – you are more than welcome to push this button
                            </p>
                            <div class="footer_btn">
                                <button class="button button-3d surprise_btn" routerLink="/about" routerLinkActive="active"
                                        (click)="onShowContactForm()">I will surprise you
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <!--FIGURES-->

            <div class="section noborder nobottommargin notopmargin"
                 style="padding: 180px 0px;">

                <div appParallax [ratio]="-0.05" class="parallax-image bg-banner2"></div>
                <div class="bg-banner-text bg-banner2-text"></div>

                <div class="container clearfix"></div>
            </div>

            <div class="section nobottommargin notopmargin" style="background-color: white">
                <div class="container clearfix smart_container">
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 nobottommargin">
                        <div class="figures_box bg-figure1">
                            <div class="figures_number figures_number_top">
                                <p appCounter [number]="200" [dly]="1" [step]="20" (countInc)="counter1 = $event">
                                    {{counter1}}+</p>
                                <span>customers</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 nobottommargin">
                        <div class="figures_box bg-figure2">
                            <div class="figures_number figures_number_top">
                                <p appCounter [number]="40" [dly]="10" (countInc)="counter2 = $event">{{counter2}}+</p>
                                <span>countries</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 nobottommargin">
                        <div class="figures_box bg-figure3">
                            <div class="figures_number figures_number_top">
                                <p appCounter [number]="5" [dly]="5" (countInc)="counter3 = $event">{{counter3}}</p>
                                <span>continents</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 nobottommargin">
                        <div class="figures_box bg-figure4">
                            <div class="figures_number figures_number_bottom">
                                <p appCounter [number]="100" [dly]="10" [step]="10" (countInc)="counter4 = $event">{{counter4}}+</p>
                                <span>releases</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 nobottommargin">
                        <div class="figures_box bg-figure5">
                            <div class="figures_number figures_number_bottom">
                                <p appCounter [number]="5000" [dly]="1" [step]="500" (countInc)="counter5 = $event">
                                    {{counter5}}+</p>
                                <span>feature<br> requests<br> implemented</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 nobottommargin">
                        <div class="figures_box bg-figure6">
                            <div class="figures_number figures_number_bottom">
                                <p appCounter [number]="25000" [dly]="1" [step]="2500" (countInc)="counter6 = $event">
                                    {{counter6}}</p>
                                <span>SMS per second</span>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
            <!--FAST SECURE SELECT-->


            <div class="section noborder notopmargin nobottommargin"
                 style="padding: 180px 0px;">
                <div appParallax [ratio]="-0.2" class="parallax-image bg-banner4"></div>
                <div class="bg-banner-text bg-banner4-text"></div>
                <div class="container clearfix"></div>
            </div>


            <div class="section nobottommargin notopmargin" style="background-color: initial">
                <div class="container clearfix smart_container">
                    <div class="col_one_third text-box">
                        <div class="feature-box with_icon">
                            <div class="feature-box-header">
                                <div class="h-icon h-icon-raketa"></div>
                                <h2>FREQUENT<br>NEW RELEASES</h2>
                            </div>
                            <p>Just keep calm and update. You will get spoiled by always having all the benefits of
                                frequent new
                                releases of our products. No hidden costs involved.</p>
                        </div>
                    </div>

                    <div class="col_one_third text-box">
                        <div class="feature-box with_icon">
                            <div class="feature-box-header">
                                <div class="h-icon h-icon-bell"></div>
                                <h2>FREE FEATURE<br>REQUESTS</h2>
                            </div>
                            <p>We always welcome creative suggestions. In fact, most of the best features we have are a
                                direct result
                                of our clients’ requests. Rocket science routing, scrupulous reporting –
                                ever-resourceful clients are a
                                blessing we cherish.
                            </p>
                        </div>
                    </div>

                    <div class="col_one_third col_last text-box">
                        <div class="feature-box with_icon">
                            <div class="feature-box-header">
                                <div class="h-icon h-icon-garnitura"></div>
                                <h2>TECHNICAL<br>SUPPORT
                                </h2>
                            </div>
                            <p>Exceptional service level for maximum results. It takes us a 1-year training cycle to get
                                you the best
                                possible support experts to serve your needs beyond expectations. An ongoing challenge
                                we ingeniously
                                handle. 
                            </p>
                        </div>
                    </div>

                    <div class="clear"></div>

                    <div class="col_one_third nobottommargin  text-box">
                        <div class="feature-box with_icon">
                            <div class="feature-box-header">
                                <div class="h-icon h-icon-monitor"></div>
                                <h2>USER-FRIENDLY <br>INTERFACES
                                </h2>
                            </div>
                            <p>All Alaris solutions are user-friendly and designed to be as much self-explanatory as
                                possible for any
                                user: be that an experienced telecom ace or a newbie. 
                            </p>
                        </div>
                    </div>

                    <div class="col_one_third nobottommargin  text-box">
                        <div class="feature-box with_icon">
                            <div class="feature-box-header">
                                <div class="h-icon h-icon-youtube"></div>
                                <h2>WATCH US <br>ON YOUTUBE</h2>
                            </div>
                            <p>Today's world is more a world of watchers than readers - so check out our YouTube channel
                                for fresh
                                release notes, vivid howto's... and some insight into the daily life of our team :)
                            </p>
                        </div>
                    </div>

                    <div class="col_one_third nobottommargin col_last text-box">
                        <div class="feature-box with_icon">
                            <div class="feature-box-header">
                                <div class="h-icon h-icon-settings"></div>
                                <h2>ACROBATIC<br>FLEXIBILITY
                                </h2>
                            </div>
                            <p>It’s your game - you select the rules. Hosted or on-premises, one-time or MRC, license or
                                service. You
                                want it different? Just tell us.
                            </p>
                        </div>
                    </div>

                </div>
            </div>


            <!--SMART SELECT-->

            <div class="section noborder notopmargin nobottommargin" #smart
                 style="padding: 180px 0px;">

                <div appParallax [ratio]="-0.06" class="parallax-image bg-banner5"></div>
                <div class="bg-banner-text bg-banner5-text"></div>
                <div class="container clearfix"></div>
            </div>


            <div class="section nobottommargin notopmargin" style="background: white; ">
                <div class="container clearfix messaging">

                    <div class="center noborder">
                        <p style="font-size: 24px;">Please select all the applicable options below for us to better
                            address your
                            needs</p>

                        <div href="#" class="button button-3d nomargin center"
                             (click)="onShowDetails()">
                            {{(smartDetials) ? "HIDE SMART SELECT" : "PLEASE SELECT"}}

                        </div>
                    </div>

                    <div class="container">
                        <div class="row smart_container">
                            <div class="col col-lg-3 col-sm-6 col-xs-12" (click)="onShowDetails(1)">
                                <div [class]="smartDetials ? 'smart-box smart_details' : 'smart-box'" #smartBox1
                                     [style.height]="smartHeight1">
                                    <div class="smart-icon smart-icon-market"></div>
                                    <h3>YOUR MARKET</h3>
                                    <span> Voice wholesale,
                    SMS wholesale,
                    Enterprise messaging<br>
                  </span>
                                    <ul *ngIf="smartDetials">
                                        <li [class]="smartModel.Market.VoiceWholesale ? 'checked' : ''"
                                            (click)="onChangeSmartModel('Market.VoiceWholesale'); $event.stopPropagation();">
                                            Voice Wholesale
                                        </li>
                                        <li [class]="smartModel.Market.SMSHubbing ? 'checked' : ''"
                                            (click)="onChangeSmartModel('Market.SMSHubbing'); $event.stopPropagation();">
                                            SMS Hubbing
                                        </li>
                                        <li [class]="smartModel.Market.EnterpriseMessaging ? 'checked' : ''"
                                            (click)="onChangeSmartModel('Market.EnterpriseMessaging'); $event.stopPropagation();">
                                            Enterprise Messaging
                                        </li>
                                        <li [class]="smartModel.Market.Custom ? 'checked' : ''"
                                            (click)="onChangeSmartModel('Market.Custom'); $event.stopPropagation();">I
                                            have in mind something else
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="col col-lg-3 col-sm-6 col-xs-12" (click)="onShowDetails(1)">
                                <div [class]="smartDetials ? 'smart-box smart_details' : 'smart-box'"
                                     [style.height]="smartHeight1">
                                    <div class="smart-icon smart-icon-premises"></div>
                                    <h3>Deployment Type</h3>
                                    <span>SaaS or customer-premises deployment</span>
                                    <ul *ngIf="smartDetials">
                                        <li [class]="smartModel.Premises.SaaS ? 'checked' : ''"
                                            (click)="onChangeSmartModel('Premises.SaaS'); $event.stopPropagation();">
                                            SaaS
                                        </li>
                                        <li [class]="smartModel.Premises.MyPremises ? 'checked' : ''"
                                            (click)="onChangeSmartModel('Premises.MyPremises'); $event.stopPropagation();">
                                            My premises
                                        </li>
                                        <li [class]="smartModel.Premises.Custom ? 'checked' : ''"
                                            (click)="onChangeSmartModel('Premises.Custom'); $event.stopPropagation();">I
                                            have in mind an exceptional setup
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="col col-lg-3 col-sm-6 col-xs-12" (click)="onShowDetails(1)">
                                <div [class]="smartDetials ? 'smart-box smart_details' : 'smart-box'"
                                     [style.height]="smartHeight2">
                                    <div class="smart-icon smart-icon-payment"></div>
                                    <h3>PAYMENT STRUCTURE</h3>
                                    <span>MRC, one-time, instalment plan </span>
                                    <ul *ngIf="smartDetials">
                                        <li [class]="smartModel.PaymentStructure.MRC ? 'checked' : ''"
                                            (click)="onChangeSmartModel('PaymentStructure.MRC'); $event.stopPropagation();">
                                            MRC
                                        </li>
                                        <li [class]="smartModel.PaymentStructure.OneTime ? 'checked' : ''"
                                            (click)="onChangeSmartModel('PaymentStructure.OneTime'); $event.stopPropagation();">
                                            One-time
                                        </li>
                                        <li [class]="smartModel.PaymentStructure.InstalmentPlan ? 'checked' : ''"
                                            (click)="onChangeSmartModel('PaymentStructure.InstalmentPlan'); $event.stopPropagation();">
                                            Instalment Plan
                                        </li>
                                        <li [class]="smartModel.PaymentStructure.Custom ? 'checked' : ''"
                                            (click)="onChangeSmartModel('PaymentStructure.Custom'); $event.stopPropagation();">
                                            My commercial imagination is beyond
                                            standard
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="col col-lg-3 col-sm-6 col-xs-12" (click)="onShowDetails(1)">
                                <div [class]="smartDetials ? 'smart-box smart_details' : 'smart-box'" #smartBox2>
                                    <div class="smart-icon smart-icon-business"></div>
                                    <h3>BUSINESS LEVEL</h3>
                                    <span>Easy-to-go start-up package, medium-range carrier-grade package, VIP package with all additional modules and services</span>
                                    <ul *ngIf="smartDetials">
                                        <li [class]="smartModel.BusinessLevel.HelpMeToStart ? 'checked' : ''"
                                            (click)="onChangeSmartModel('BusinessLevel.HelpMeToStart'); $event.stopPropagation();">
                                            Help me to start
                                        </li>
                                        <li [class]="smartModel.BusinessLevel.MyGrowingBusiness ? 'checked' : ''"
                                            (click)="onChangeSmartModel('BusinessLevel.MyGrowingBusiness'); $event.stopPropagation();">
                                            My growing business needs a
                                            better solution
                                        </li>
                                        <li [class]="smartModel.BusinessLevel.Custom ? 'checked' : ''"
                                            (click)="onChangeSmartModel('BusinessLevel.Custom'); $event.stopPropagation();">
                                            I am exceptional, fold it all up for me
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>


                        <!--<div class="clear"></div>-->

                    </div>
                    <div class="center noborder">
                        <div *ngIf="smartDetials"
                             class="button button-3d nomargin center"
                             (click)="onShowSmartForm()">
                            REQUEST
                            <!--<span>all the applicable options below for us to better address your needs</span>-->
                        </div>
                    </div>

                </div>
            </div>

            <div class="section dark parallax notopmargin nobottommargin noborder creative-team">

                <div class="container clearfix">

                    <div class="slider-caption slider-caption-center" style="position: relative; color: white" #team>
                        <div data-animate="fadeInUp" class="fadeInUp animated">
                            <h1 style="text-transform: uppercase; font-size: 48px;">Creative Team</h1>
                            <p style="text-align: justify">The blend of creativity and deep technical expertise is one
                                of our strongest suits.
                                Alaris Labs
                                professionals easily translate your needs into innovative features that give you a real
                                strategic
                                advantage on the telecom market. Your business will definitely do better with Alaris
                                Labs working on
                                your side. </p>
                        </div>
                    </div>

                </div>

                <div class="video-wrap">

                    <video poster="/assets/images/about/videos/office_work.jpg" preload="auto" loop autoplay muted>
                        <source src='/assets/images/about/videos/office_work.mp4' type='video/mp4' />
                        <source src='/assets/images/about/videos/office_work.webm' type='video/webm' />
                    </video>
                    <div class="video-overlay" style="background-color: rgba(0,0,0,0.3);"></div>
                </div>

            </div>


            <div class="section nobottommargin notopmargin" style="background: white;" #contacts>
                <div class="container clearfix">

                    <div class="clear" id="contacts"></div>
                    <div class="footer parallax-image bg-footer"></div>

                    <div id="section-contact" class="heading-block title-center page-section nobottomborder">
                        <div routerLink="/contacts" class="cat"></div>
                        <a href="/contacts" target="_self" style="padding: 0 37px !important;"
                                routerLink="/contacts" class="button button-3d nomargin" type="submit"
                                id="template-contactform-submit"
                                name="template-contactform-submit" value="submit" (click)="false;">GET IN TOUCH WITH US
                        </a>


                    </div>


                </div>
            </div>

        </div>

    </section><!-- #content end -->


</div>
<!--</div>-->

<!-- Go To Top
============================================= -->
<div class ="icon-angle-up goTopBtn"
     [class.display-block]="!(showSmartForm || showContactForm || dockShow)"
     [class.display-none]="(showSmartForm || showContactForm || dockShow)"
     (click)="scrollToEl(home);">
</div>

<smart-form *ngIf="showSmartForm" [show]="showSmartForm" (onClose)="onCloseSmartForm($event)"></smart-form>
<!--<about-contact-form *ngIf="showContactForm" [show]="showContactForm" (onClose)="onCloseContactForm($event)"></about-contact-form>-->
<about-form *ngIf="showContactForm" [show]="showContactForm" (onClose)="onCloseContactForm($event)"></about-form>
